<template>
  <div>
    <headerNav title="修改登录密码" />
    <van-form @submit="confirm">
      <van-field
        v-model="payinput.currentPassword"
        type="password"
        name="旧密码"
        label="旧密码"
        placeholder="请输入旧密码"
        :rules="[{ required: true, message: '请填写旧密码' }]"
      />
      <van-field
        v-model="payinput.newPassword"
        type="password"
        name="新密码"
        label="新密码"
        placeholder="请输入新密码"
        :rules="[{ required: true, message: '请填写新密码' }]"
      />
      <van-field
        v-model="payinput.newPassword1"
        type="password"
        name="确认密码"
        label="确认密码"
        placeholder="请再次输入确认密码"
        :rules="[{ required: true, message: '请填写确认密码' }]"
      />
      <div style="margin: 16px;">
        <van-button
          round
          block
          type="info"
          native-type="submit"
          :loading="loading"
          loading-text="设置中..."
          class="setbtns"
          :color="$abctheme.basecolor"
        >提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import request from "@/config/ajax";

import Util from "@/config/Util";

export default {
  data() {
    return {
      payinput: {
        currentPassword: "",
        newPassword: "",
        newPassword1: "",
      },
      loading: false,
      ispay: false,
    };
  },
  create() {
    if (!Util.abp.session.userId) {
      this.$router.push({ path: "/login/password" });
    } else {
      var option = this.$route.params;
      if (option.ispay) {
        this.ispay = true;
      }
    }
  },
  methods: {
    confirm() {
      this.loading = true;
      if(this.payinput.newPassword!=this.payinput.newPassword1)
      {
            this.$toast({message:'两次密码不一致'});
            return;
      }
     
      request
        .post("/api/services/app/PhoneUser/ChangePhonePassword", this.payinput)
        .then(() => {
          this.$toast({message:'设置成功'});
          //立即退出登录
          //返回上个页面并触发方法
           this.abp.auth.clearToken();
           location.reload();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>
